// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","noShrink":"styles_noShrink__S8SJ8","submit":"styles_submit__1mW8U","icon":"styles_icon__2aZ2d"};